export default "ab5b1239006ea9b2.svg"